import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FullBorderedGrid from './FullBorderedGrid';
import ClientProvider from './client';
export default createDemo(import.meta.url, FullBorderedGrid, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/grid/demos/full-bordered/FullBorderedGrid.tsx",
    "fileName": "FullBorderedGrid.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\n\nexport default function FullBorderedGrid() {\n  return (\n    <Box sx={{ flexGrow: 1, p: 2 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Grid\n        container\n        sx={{\n          '--Grid-borderWidth': '1px',\n          borderTop: 'var(--Grid-borderWidth) solid',\n          borderLeft: 'var(--Grid-borderWidth) solid',\n          borderColor: 'divider',\n          '& > div': {\n            borderRight: 'var(--Grid-borderWidth) solid',\n            borderBottom: 'var(--Grid-borderWidth) solid',\n            borderColor: 'divider',\n          },\n        }}\n      >\n        {[...Array(6)].map((_, index) => (\n          <Grid\n            key={index}\n            size={{\n              xs: 12,\n              sm: 6,\n              md: 4,\n              lg: 3,\n            }}\n            sx={{ minHeight: 160 }}\n          />\n        ))}\n      </Grid>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 36,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport Grid from '@mui/material/Grid';\n\nexport default function FullBorderedGrid() {\n  return (\n    <Box sx={{ flexGrow: 1, p: 2 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Grid\n        container\n        sx={{\n          '--Grid-borderWidth': '1px',\n          borderTop: 'var(--Grid-borderWidth) solid',\n          borderLeft: 'var(--Grid-borderWidth) solid',\n          borderColor: 'divider',\n          '& > div': {\n            borderRight: 'var(--Grid-borderWidth) solid',\n            borderBottom: 'var(--Grid-borderWidth) solid',\n            borderColor: 'divider',\n          },\n        }}\n      >\n        {[...Array(6)].map((_, index) => (\n          <Grid\n            key={index}\n            size={{\n              xs: 12,\n              sm: 6,\n              md: 4,\n              lg: 3,\n            }}\n            sx={{ minHeight: 160 }}\n          />\n        ))}\n      </Grid>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "totalLines": 36,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/Grid"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
